import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Config } from '../../../infrastructure/config';
import { RequestHelper } from '../../../infrastructure/core/requestHelper';
import { Favourite } from '../../../models/DTO/favourite/favourite';
import { createFavouriteRequestModel } from '../../../models/requestModels/favourites/createFavouriteRequestModel';

@Injectable({
  providedIn: 'root'
})
export class FavouritesService {

  private favouritesApiRouteURL : string = Config.api + 'user/wishlist';

  constructor(private http: HttpClient) { }

  generateFavourite(favourite: createFavouriteRequestModel) {
    return this.http.post(this.favouritesApiRouteURL, favourite);
  }

  removeFavourite(favourite: createFavouriteRequestModel) {
    return this.http.request('delete', this.favouritesApiRouteURL, {body: favourite});
  }

  getFavourites() {
    return this.http.get<Favourite>(this.favouritesApiRouteURL);
  }

  isProductFavouriteRequest(itemId: string) {
    const params = RequestHelper.addMultipleParams([
      {
        key: 'productId.equals',
        value: itemId
      }
    ]);
    return this.http.get<Favourite>(this.favouritesApiRouteURL + params);
  }

  deleteFavouriteProduct(itemId: string) {
    const params = RequestHelper.addRESTParams([
      itemId.toString()
    ])
    return this.http.delete(this.favouritesApiRouteURL + params);
  }

  createFavouriteProduct(favourite: createFavouriteRequestModel) {
    return this.http.post<Favourite>(this.favouritesApiRouteURL, favourite);
  }

  getAllFavouritesForUser(userId: string) {
    const params = RequestHelper.addMultipleParams([
      {
        key: 'userId.equals',
        value: userId
      },
      {
        key: 'include',
        value: 'pricing'
      }
    ])
    return this.http.get<Favourite>(this.favouritesApiRouteURL + params)
  }
}
